import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { AuthTokenResponse } from './use-create-customer';

type Variables = {
  googleCredential: string;
  referralCode?: string;
  promoCode?: string;
};

export const useLoginCustomerGoogle = createMutation<
  AuthTokenResponse,
  Variables,
  AxiosError
>({
  mutationFn: async ({ googleCredential, referralCode, promoCode }) =>
    client({
      url: 'v2/login/google',
      method: 'POST',
      data: {
        google_credential: googleCredential,
        referral_code: referralCode,
        promo_code: promoCode,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
